<template>
    <div>
        <a class="text-bold title-link" :href="'#' + link">{{__(value, ['capFirst'])}}</a>
    </div>
</template>
<script>
import Vue from 'vue';

export default {
    data() {
        return {

        }
    },

    components: {

    },

    props: ['initialValue', 'css', 'data', 'config'],

    computed: {
        link() {
            return this.helpers('uriFormat')(_.get(this.data, 'link', ''));
        },
        value() {
            const handler = _.get(this.config, 'handler', (value, data) => value || '');
            return handler(this.initialValue, this.data, this.__);
        }
    },

    mounted() {

    },

    methods: {

    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/table-elements/LinkTitleComponent.vue